import * as types from '../Actions/types';

const INIT_STATE = {
    data: []
};

const User = (state = INIT_STATE, action) => {
    switch(action.type){
        case types.INIT_LOGOUT:
            return INIT_STATE;

        case types.USER_DATA:
            return{
                ...state,
                data: action.data
            }

        default:
            return state;
    }
};

export default User;